export default "__VITE_ASSET__BwtpSilp__"